import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateItemAliasFormAction } from '../_state/itemAliasForm.state';
import { ItemAliasRecord } from '../types/inventoryItem';

type Props = {
  itemAlias?: ItemAliasRecord | null;
};

export const usePopulateItemAliasForm = ({ itemAlias }: Props) => {
  const populateForm = useSetAtom($populateItemAliasFormAction);

  React.useEffect(() => {
    populateForm(itemAlias);
  }, [itemAlias, populateForm]);
};
